import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    NumberField,
} from 'react-admin'


export const RegionShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" label="ID"/>
            <NumberField source="code" label="Código" />
            <TextField source="name" label="Nombre" />
            <TextField source="full_name" label="Nombre Largo" />
        </SimpleShowLayout>
    </Show>
);
